/**
 * @fileoverview gRPC-Web generated client stub for proto.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: proto/services/auth_service.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as proto_services_auth_service_pb from '../../proto/services/auth_service_pb';


export class AuthServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreateAuthToken = new grpcWeb.MethodDescriptor(
    '/proto.services.AuthService/CreateAuthToken',
    grpcWeb.MethodType.UNARY,
    proto_services_auth_service_pb.CreateAuthRequest,
    proto_services_auth_service_pb.CreateAuthResponse,
    (request: proto_services_auth_service_pb.CreateAuthRequest) => {
      return request.serializeBinary();
    },
    proto_services_auth_service_pb.CreateAuthResponse.deserializeBinary
  );

  createAuthToken(
    request: proto_services_auth_service_pb.CreateAuthRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_auth_service_pb.CreateAuthResponse>;

  createAuthToken(
    request: proto_services_auth_service_pb.CreateAuthRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.CreateAuthResponse) => void): grpcWeb.ClientReadableStream<proto_services_auth_service_pb.CreateAuthResponse>;

  createAuthToken(
    request: proto_services_auth_service_pb.CreateAuthRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.CreateAuthResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.AuthService/CreateAuthToken',
        request,
        metadata || {},
        this.methodDescriptorCreateAuthToken,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.AuthService/CreateAuthToken',
    request,
    metadata || {},
    this.methodDescriptorCreateAuthToken);
  }

  methodDescriptorCreateTransferToken = new grpcWeb.MethodDescriptor(
    '/proto.services.AuthService/CreateTransferToken',
    grpcWeb.MethodType.UNARY,
    proto_services_auth_service_pb.CreateTransferTokenRequest,
    proto_services_auth_service_pb.CreateTransferTokenResponse,
    (request: proto_services_auth_service_pb.CreateTransferTokenRequest) => {
      return request.serializeBinary();
    },
    proto_services_auth_service_pb.CreateTransferTokenResponse.deserializeBinary
  );

  createTransferToken(
    request: proto_services_auth_service_pb.CreateTransferTokenRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_auth_service_pb.CreateTransferTokenResponse>;

  createTransferToken(
    request: proto_services_auth_service_pb.CreateTransferTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.CreateTransferTokenResponse) => void): grpcWeb.ClientReadableStream<proto_services_auth_service_pb.CreateTransferTokenResponse>;

  createTransferToken(
    request: proto_services_auth_service_pb.CreateTransferTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.CreateTransferTokenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.AuthService/CreateTransferToken',
        request,
        metadata || {},
        this.methodDescriptorCreateTransferToken,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.AuthService/CreateTransferToken',
    request,
    metadata || {},
    this.methodDescriptorCreateTransferToken);
  }

  methodDescriptorLogin = new grpcWeb.MethodDescriptor(
    '/proto.services.AuthService/Login',
    grpcWeb.MethodType.UNARY,
    proto_services_auth_service_pb.LoginRequest,
    proto_services_auth_service_pb.LoginResponse,
    (request: proto_services_auth_service_pb.LoginRequest) => {
      return request.serializeBinary();
    },
    proto_services_auth_service_pb.LoginResponse.deserializeBinary
  );

  login(
    request: proto_services_auth_service_pb.LoginRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_auth_service_pb.LoginResponse>;

  login(
    request: proto_services_auth_service_pb.LoginRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.LoginResponse) => void): grpcWeb.ClientReadableStream<proto_services_auth_service_pb.LoginResponse>;

  login(
    request: proto_services_auth_service_pb.LoginRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.LoginResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.AuthService/Login',
        request,
        metadata || {},
        this.methodDescriptorLogin,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.AuthService/Login',
    request,
    metadata || {},
    this.methodDescriptorLogin);
  }

  methodDescriptorSignup = new grpcWeb.MethodDescriptor(
    '/proto.services.AuthService/Signup',
    grpcWeb.MethodType.UNARY,
    proto_services_auth_service_pb.SignupRequest,
    proto_services_auth_service_pb.SignupResponse,
    (request: proto_services_auth_service_pb.SignupRequest) => {
      return request.serializeBinary();
    },
    proto_services_auth_service_pb.SignupResponse.deserializeBinary
  );

  signup(
    request: proto_services_auth_service_pb.SignupRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_auth_service_pb.SignupResponse>;

  signup(
    request: proto_services_auth_service_pb.SignupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.SignupResponse) => void): grpcWeb.ClientReadableStream<proto_services_auth_service_pb.SignupResponse>;

  signup(
    request: proto_services_auth_service_pb.SignupRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.SignupResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.AuthService/Signup',
        request,
        metadata || {},
        this.methodDescriptorSignup,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.AuthService/Signup',
    request,
    metadata || {},
    this.methodDescriptorSignup);
  }

  methodDescriptorGetIDPAuthCodeUrl = new grpcWeb.MethodDescriptor(
    '/proto.services.AuthService/GetIDPAuthCodeUrl',
    grpcWeb.MethodType.UNARY,
    proto_services_auth_service_pb.GetIDPAuthCodeUrlRequest,
    proto_services_auth_service_pb.GetIDPAuthCodeUrlResponse,
    (request: proto_services_auth_service_pb.GetIDPAuthCodeUrlRequest) => {
      return request.serializeBinary();
    },
    proto_services_auth_service_pb.GetIDPAuthCodeUrlResponse.deserializeBinary
  );

  getIDPAuthCodeUrl(
    request: proto_services_auth_service_pb.GetIDPAuthCodeUrlRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_auth_service_pb.GetIDPAuthCodeUrlResponse>;

  getIDPAuthCodeUrl(
    request: proto_services_auth_service_pb.GetIDPAuthCodeUrlRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.GetIDPAuthCodeUrlResponse) => void): grpcWeb.ClientReadableStream<proto_services_auth_service_pb.GetIDPAuthCodeUrlResponse>;

  getIDPAuthCodeUrl(
    request: proto_services_auth_service_pb.GetIDPAuthCodeUrlRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.GetIDPAuthCodeUrlResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.AuthService/GetIDPAuthCodeUrl',
        request,
        metadata || {},
        this.methodDescriptorGetIDPAuthCodeUrl,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.AuthService/GetIDPAuthCodeUrl',
    request,
    metadata || {},
    this.methodDescriptorGetIDPAuthCodeUrl);
  }

  methodDescriptorAddUserThirdPartyIDP = new grpcWeb.MethodDescriptor(
    '/proto.services.AuthService/AddUserThirdPartyIDP',
    grpcWeb.MethodType.UNARY,
    proto_services_auth_service_pb.AddUserIdpRequest,
    proto_services_auth_service_pb.LoginResponse,
    (request: proto_services_auth_service_pb.AddUserIdpRequest) => {
      return request.serializeBinary();
    },
    proto_services_auth_service_pb.LoginResponse.deserializeBinary
  );

  addUserThirdPartyIDP(
    request: proto_services_auth_service_pb.AddUserIdpRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_auth_service_pb.LoginResponse>;

  addUserThirdPartyIDP(
    request: proto_services_auth_service_pb.AddUserIdpRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.LoginResponse) => void): grpcWeb.ClientReadableStream<proto_services_auth_service_pb.LoginResponse>;

  addUserThirdPartyIDP(
    request: proto_services_auth_service_pb.AddUserIdpRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_auth_service_pb.LoginResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.AuthService/AddUserThirdPartyIDP',
        request,
        metadata || {},
        this.methodDescriptorAddUserThirdPartyIDP,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.AuthService/AddUserThirdPartyIDP',
    request,
    metadata || {},
    this.methodDescriptorAddUserThirdPartyIDP);
  }

}

